// extracted by mini-css-extract-plugin
export default {"disabled":"XtH18","stretchToContainer":"_0TxZg"};